/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';
import { DataFormField, DataFormModel } from '../../state/dataForm.model';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'dash-gis-base-field',
    templateUrl: './base-field.component.html',
})
export class BaseFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
    @Input() public tableEditActive: boolean;
    @Input() public tableDataFormName: string;
    @Input() public dataFormGroup: UntypedFormGroup;
    @Input() public dataForm: DataFormModel;
    @Input() public dropdownParameterValue: any;

    get dataFormField(): DataFormField {
        let f = null;
        if (this.dataForm) {
            f = this.dataForm.definition.fields.find((field) => field.fieldName === this.fieldDefinition.name);
        }
        return f;
    }

    get isEditable(): boolean {
        return !!this.dataFormField;
    }
}
